export default __webpack_public_path__ + "static/media/search.e69ca8d8.svg";